const RANGE_EXPRESSION_SEPARATOR = '%2E'

const decodeQueryParamKeys = (query) =>
  Object.entries(query).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [decodeURIComponent(key)]: value,
    }),
    {},
  )

export { RANGE_EXPRESSION_SEPARATOR, decodeQueryParamKeys }
